import { render, staticRenderFns } from "./DataByIndustry.vue?vue&type=template&id=51cf3656"
import script from "./DataByIndustry.vue?vue&type=script&lang=js"
export * from "./DataByIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports